// extracted by mini-css-extract-plugin
export default {"imageSwitcher":"ImageSwitcher_imageSwitcher__UK48g","image":"ImageSwitcher_image__zH0eg","arrow":"ImageSwitcher_arrow__ij4O0"};